import * as React from 'react'
import { SVGProps } from 'react'

const SvgUstIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 22.5' xmlns='http://www.w3.org/2000/svg' {...props}>
    <clipPath id='UstIcon_svg__a'>
      <path d='M0 7.5h7.5v15H0z' />
    </clipPath>
    <clipPath id='UstIcon_svg__b'>
      <circle cx={11.8} cy={12.3} r={12.2} />
    </clipPath>
    <path
      d='M10.6 18.3c.6 2.4 2.9 4.3 4.1 4.2 2.8-.7 5.3-2.4 6.8-4.9 1.9-3.2 1.2-6.2-1.3-6.3-1 0-10.8 2.4-9.6 7M12.8 0c-1.6 0-3.2.3-4.6 1-.3.1-.5.2-.7.4l-.5.2c-.5.3-.9.7-1.2 1.1-3.2 4.3 7.7 7.4 13.5 7.5 2.7 1.9 3.4-5.4.8-7.5C18.1 1 15.5 0 12.8 0'
      fill='#0e3ca5'
    />
    <path
      d='M8.7 2.5C7.2 4.7 2.3 6.2 1.5 6l.1-.2c.8-1.6 2-3 3.5-4l.9-.6C6.5.9 7.1.8 7.7.8c2.1 0 1 1.7 1 1.7'
      fill='#5493f7'
    />
    <g clipPath='url(#UstIcon_svg__a)'>
      <path
        d='M7.5 18.7c.1 1.3 0 2.5-.2 3.8-.4 0-.8-.2-1.2-.4-1.5-.8-2.8-2-3.8-3.4-.7-1-1.3-2.1-1.7-3.3-.9-2.6-.8-5.4.1-7.9.9 1.1 1.9 2.2 2.8 3.4s2 2.9 2.2 3.3c.9 1.3 1.5 2.9 1.8 4.5'
        fill='#5493f7'
      />
    </g>
    <path
      d='M24 11.8c0 1.5-.3 3-.8 4.3-1.4 1.5-10.8-2.2-10.9-2.2-1.3-.6-5.2-2.3-5.5-5-.5-3.9 7.3-6.6 10.8-6.7.8 0 1.7.2 2.4.6 2.5 2.3 4 5.6 4 9m-8.2 9.6c.6-2 5.5-4 6.5-4.1.1 0 .2.1.1.2-1.1 2-2.8 3.7-4.8 4.8-1 .5-2.1.1-1.8-.9'
      fill='#5493f7'
    />
    <g clipPath='url(#UstIcon_svg__b)'>
      <path
        d='M15.2 10.8H24l-.3.6.3.6v1.3l-.3.6.3.6V16l-.3.6.3.6v1.3l-.3.6.3.6V21l-.3.6.3.6H8.4l.3-.6-.3-.6v-1.3l.3-.6-.3-.6v-1.3l.3-.6-.3-.6z'
        fill='#d6062f'
      />
      <path
        d='M8.4 21.2H24v1.3H8.4zM8.4 18.6H24v1.3H8.4zM8.4 16H24v1.3H8.4zM15.2 13.4H24v1.3h-8.8zM15.2 10.8H24v1.3h-8.8z'
        fill='#fff'
      />
      <path d='M8.4 10.8h6.8V16H8.4z' fill='#2956b0' />
      <g fill='#fff'>
        <path d='m9.6 11.1.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM11.1 11.1l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5zM12.6 11.1l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM14.1 11.1l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5zM9.6 12.4l.1.3h.3l-.3.2.1.3-.2-.2-.3.2.1-.3-.3-.2h.3zM11.1 12.4l.1.3h.3l-.3.2.1.3-.2-.2-.3.2.1-.3-.3-.2h.4zM12.6 12.4l.1.3h.3l-.3.2.1.3-.2-.2-.3.2.1-.3-.3-.2h.3zM14.1 12.4l.1.3h.3l-.3.2.1.3-.2-.2-.3.2.1-.3-.3-.2h.4zM9.6 13.6l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM11.1 13.6l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5zM12.6 13.6l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM14.1 13.6l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5zM9.6 14.9l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM11.1 14.9l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5zM12.6 14.9l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.3zM14.1 14.9l.1.3h.3l-.3.2.1.3-.3-.2-.3.2.1-.3-.3-.2h.5z' />
      </g>
    </g>
  </svg>
)

export default SvgUstIcon
